import { Component, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { PlatformService } from '../../platform.service';

// Live store listings + official badges — the same URLs the admin check-in page
// surfaces, with the App Store badge bundled LOCALLY (a remote badge "sometimes
// doesn't load" on the flaky-connection phones this banner targets; the Play
// badge was already local).
const APP_STORE_URL =
  'https://apps.apple.com/it/app/realguest/id6478608503?itscg=30200&itsct=apps_box_badge&mttnsubad=6478608503';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=it.therocks.realguest&hl=it';
const APP_STORE_BADGE = 'assets/img/app_store_en.svg';
const PLAY_STORE_BADGE = 'assets/img/google_play_en.png';

/**
 * Web-only "get the app" banner (native-hidden, dismissible). It lives on the web
 * check-in surfaces a user lands on after tapping a deep link WITHOUT the native
 * app installed — Home and the scanner they dwell on — so ask #2's "no app → nudge
 * to install" is shown on a screen they actually see, not the transient PIN screen
 * (which auto-submits a deep-linked pin and navigates straight past).
 */
@Component({
  selector: 'nbd-install-banner',
  templateUrl: './install-banner.component.html',
  styleUrl: './install-banner.component.scss',
  imports: [TranslatePipe, MatIconButton, MatIcon],
})
export class InstallBannerComponent {
  protected readonly platform = inject(PlatformService);
  protected readonly dismissed = signal(false);

  protected readonly appStoreUrl = APP_STORE_URL;
  protected readonly playStoreUrl = PLAY_STORE_URL;
  protected readonly appStoreBadge = APP_STORE_BADGE;
  protected readonly playStoreBadge = PLAY_STORE_BADGE;

  dismiss(): void {
    this.dismissed.set(true);
  }
}
